module.exports = __webpack_public_path__ + "fonts/MuseoSlab-900.7969f8b6.woff2";